/**
 * src/lib/api/bugReports.js — TICKET-1479 client for lib/handlers/bug-reports.js.
 * Every call resolves to the response body (apiFetch); failures come back as { success:false, error }.
 */
import { apiFetch } from './client';

const D = (action) => `/api/data?action=${action}`;
const post = (action, body = {}) => apiFetch(D(action), { method: 'POST', body: JSON.stringify(body) });

export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

/** Start a report. The server captures the last 15 min of this user's error rows. */
export const startBugReport = ({ route, language }) => post('bug_reports.start', {
  route,
  language,
  app_version: import.meta.env.VITE_APP_VERSION || null,
});
export const answerBugReport = (id, message, imagePath = null) =>
  post('bug_reports.answer', { id, message, ...(imagePath ? { image_path: imagePath } : {}) });
export const fetchMyBugReports = () => apiFetch(D('bug_reports.mine'));

/**
 * Upload one screenshot straight to the private bucket through a server-signed URL
 * (no storage policy for the client). ArrayBuffer body, not File (TICKET-658).
 * @returns {Promise<string>} the object path to pass to answerBugReport
 */
export async function uploadBugScreenshot(id, file, { fetchImpl = fetch } = {}) {
  if (!IMAGE_TYPES.includes(file?.type)) throw new Error('unsupported_image_type');
  const signed = await post('bug_reports.upload_url', { id, content_type: file.type });
  if (!signed?.signedUrl) throw new Error(signed?.error || 'sign_failed');
  const r = await fetchImpl(signed.signedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type, 'x-upsert': 'true' },
    body: await file.arrayBuffer(),
  });
  if (!r.ok) throw new Error(`upload_failed_${r.status}`);
  return signed.path;
}
